export const LeadsPermissions = {
  ViewandsearchinPropertyManagementLeads: {
    permissionsId: 'ee2b5e00-b027-4a71-931a-08d967db92be',
    permissionsName: 'View and search in  Property Management Leads',
    componentsId: null,
    components: null,
  },

  ViewAndSearchInSaleLeads: {
    components: null,
    componentsId: null,
    permissionsId: '477a1f80-9429-4fbe-931b-08d967db92be',
    permissionsName: 'View and search in sale leads',
  },
  ViewLeadDetails: {
    components: null,
    componentsId: null,
    permissionsId: 'aeac06d2-1031-4af6-931c-08d967db92be',
    permissionsName: 'View lead details',
  },
  ViewMatchingUnits: {
    components: null,
    componentsId: null,
    permissionsId: '0d89b54d-7154-4e01-931d-08d967db92be',
    permissionsName: 'View Matching Units',
  },
  EditLeadDetails: {
    components: null,
    componentsId: null,
    permissionsId: '288177e0-a2e6-4122-931e-08d967db92be',
    permissionsName: 'Edit lead details',
  },

  AddNewLeadInPropertyManagemntPage: {
    components: null,
    componentsId: null,
    permissionsId: '81a08432-5a98-4a60-bec6-08d96e04d1a0',
    permissionsName: 'Add new lead in property Managemnt Page',
  },
  CloneOwnerLead: {
    permissionsId: '61a0507e-e0fc-42af-c377-08dd4a6e8669',
    permissionsName: 'CLone Owner Lead',
    description: null,
    componentsId: null,
    components: null,
  },
};
